import React from "react"
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"

interface Props {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

const LogoutConfirmDialog: React.FC<Props> = ({ open, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Log Out</DialogTitle>
    <DialogContent>
      <DialogContentText>Are you sure you want to log out?</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onConfirm} color="error" variant="contained">
        Log Out
      </Button>
    </DialogActions>
  </Dialog>
)

export default LogoutConfirmDialog
